import {useConfigProvider} from "../../../config/ConfigProvider"

export function thoughtPiecesEndpoints() {
  const {cmsBlApiUrl, cmsBlApiApimKey, cmsBlApiFunctionKey} =
    useConfigProvider()

  const headers = {
    "Content-Type": "application/json",
    "X-Functions-Key": cmsBlApiFunctionKey || "",
    "Ocp-Apim-Subscription-Key": cmsBlApiApimKey || "",
  }

  const getThoughtPieces = async () => {
    const url = `${cmsBlApiUrl}/thought-pieces/overview`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  const getPodcasts = async () => {
    const url = `${cmsBlApiUrl}/thought-pieces/podcasts?limit=20&skip=0`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  const getThoughtPiecesPage = async (
    type: string | undefined,
    subtype: string | undefined,
    name: string | undefined,
    id: string | undefined,
  ) => {
    const typeParam = type ? type : ""
    const subtypeParam = subtype ? subtype : ""
    const nameParam = name ? name : ""
    const idParam = id ? id : ""

    const url = `${cmsBlApiUrl}/thought-pieces/page?type=${typeParam}&subtype=${subtypeParam}&name=${nameParam}&id=${idParam}`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  const getThoughtPiecesDiscoverNext = async (
    type: string | undefined,
    id: string | undefined,
    podcastRows: number | undefined,
    analysisRows: number | undefined,
  ) => {
    const typeParam = type ? type : ""
    const idParam = id ? id : ""

    const url = `${cmsBlApiUrl}/thought-pieces/discover-next?type=${typeParam}&id=${idParam}&podcastRows=${podcastRows}&analysisRows=${analysisRows}`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  const getThoughtPiecesAnalysisList = async () => {
    const url = `${cmsBlApiUrl}/thought-pieces/analysis?limit=4&skip=1`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  const getThoughtPiecesMainAnalysis = async () => {
    const url = `${cmsBlApiUrl}/thought-pieces/main-analysis`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

    const getMainContent = async () => {
    const url = `${cmsBlApiUrl}/main-content`
    return await fetch(url, {
      headers: headers,
    }).then((res) => res.json())
  }

  return {
    getThoughtPieces,
    getPodcasts,
    getThoughtPiecesPage,
    getThoughtPiecesDiscoverNext,
    getThoughtPiecesAnalysisList,
    getThoughtPiecesMainAnalysis,
    getMainContent
  }
}
